import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { TestimonialCard } from './TestimonialCard';
const TESTIMONIAL_INTERVAL = 10000;
const TESTIMONIALS = [{
  avatar: '/images/testimonial-antoine-blanco.jpg',
  quoteKey: 'auth.testimonials.0.quote' as const,
  nameKey: 'auth.testimonials.0.name' as const,
  roleKey: 'auth.testimonials.0.role' as const,
  companyKey: 'auth.testimonials.0.company' as const
}, {
  avatar: '/images/testimonial-yomi-denzel.webp',
  quoteKey: 'auth.testimonials.1.quote' as const,
  nameKey: 'auth.testimonials.1.name' as const,
  roleKey: 'auth.testimonials.1.role' as const,
  companyKey: 'auth.testimonials.1.company' as const
}];
export const TestimonialCarousel = () => {
  const $ = _c(6);
  const [activeIndex, setActiveIndex] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const interval = setInterval(() => {
        setActiveIndex(_temp);
      }, TESTIMONIAL_INTERVAL);
      return () => clearInterval(interval);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== activeIndex) {
    t2 = TESTIMONIALS.map((testimonial, i) => {
      let pos = i - activeIndex;
      if (pos > 1) {
        pos = pos - TESTIMONIALS.length;
      }
      if (pos < -1) {
        pos = pos + TESTIMONIALS.length;
      }
      return <TestimonialCard key={i} {...testimonial} position={pos} />;
    });
    $[2] = activeIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="w-full max-w-[520px] relative auth-fade-right-delayed"><div className="relative h-[340px]">{t2}</div></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp(prev) {
  return (prev + 1) % TESTIMONIALS.length;
}